<template>
	<div id="balances-container">
		<select  v-if=" casinosForCodeGeneration.length > 1" class="center-select" title="Select Casino" v-model="casinoIdNumber" id="casinoId">
			<option v-for="casino in  casinosForCodeGeneration" v-bind:key="casino" :value="casino.id">
				{{ casino.name }}
			</option>
		</select>
		<h3>{{ languageStrings.casinoBalance }}</h3>
		<button
			v-if="
				(systemSettings?.features?.allowBarcodeAccountAccess ||
					systemSettings?.features?.allowVerbalCodeAccountAccess) &&
				playerState.isUserVerified &&
				systemSettings?.features?.allowMultiCasinoAccountAccessCodes &&
				countryCode !== 'MX'
			"
			@click="requestOpenQRCodeModal()"
			class="btn"
		>
			{{ languageStrings.getQRcode }} {{ casinoName }}
		</button>
		<table>
		<table class="balances second-table-container">
			<!-- <thead>
			<tr class="header-row">
				<th>Casino</th>
				<th>Regular</th>
				<th>{{ languageStrings.promo }}</th>
				<th>{{ languageStrings.lockedFunds }}</th>
				<th>{{ languageStrings.lockFundsCount }}</th>
				<th
					v-if="
						(systemSettings?.features?.allowBarcodeAccountAccess ||
							systemSettings?.features?.allowVerbalCodeAccountAccess) &&
						playerState.isUserVerified &&
						!systemSettings?.features?.allowMultiCasinoAccountAccessCodes &&
						countryCode !== 'MX'
					"
				>
					{{ languageStrings.codeAvailable }}
				</th>
			</tr>
		</thead> -->
		<tbody v-for="(item, index) in casinoBalanceToShow" @click="setOpenClass(index)" :key="index" :id="`row-${index}`">
			<tr class="data-row curved-border" >
				<td v-if="countryCode !== 'MX'" id="home-casino-name" class="encore-color">
					{{ item.name }}
					<i class="arrow down"></i>
				</td>
				<td v-else id="home-casino-name" class="encore-color">
					{{ languageStrings.balance }}
				</td>
				<!-- <td class="encore-color">
					{{ item.currencyTool.formatFromAU(item.balance.regularAU, item.currencyTool.displayType.full) }}
				</td>
				<td id="home-promotions">{{ item.currencyTool.formatFromAU(item.balance.promoAU, item.currencyTool.displayType.full) }}</td>
				<td class="pink-red-color">{{ item.currencyTool.formatFromAU(item.lockedFundsAU, item.currencyTool.displayType.full) }}</td>
				<td class="encore-color">{{ item.lockedClaimsCount }}</td>
				<td
					v-if="
						(systemSettings?.features?.allowBarcodeAccountAccess ||
							systemSettings?.features?.allowVerbalCodeAccountAccess) &&
						playerState.isUserVerified &&
						!systemSettings?.features?.allowMultiCasinoAccountAccessCodes &&
						countryCode !== 'MX'
					"
				>
					<button @click="requestOpenQRCodeModal(item.id)" :title="languageStrings.getQRcode" class="btn">
						{{ languageStrings.getQRcode }}
					</button>
				</td> -->
			</tr>
			<tr class="panel">
				<td class="encore-color">
					<table class="full-width">
						<tr>
							<td v-if="countryCode !== 'MX'">Regular</td>
							<td v-else >Redimibles</td>
							<td class="numerical-font-bold">{{ item.currencyTool.formatFromAU(item.balance.regularAU, item.currencyTool.displayType.full) }}</td>
						</tr>
						<tr>
							<td>{{ languageStrings.promo }}</td>
							<td class="numerical-font-bold" id="home-promotions">{{ item.currencyTool.formatFromAU(item.balance.promoAU, item.currencyTool.displayType.full) }}</td>
						</tr>
						<tr v-if="item.lockedFundsAU">
							<td>{{ languageStrings.lockedFunds }}</td>
							<td class="pink-red-color numerical-font-bold">{{ item.currencyTool.formatFromAU(item.lockedFundsAU, item.currencyTool.displayType.full) }}</td>
						</tr>
						<tr v-if="item.lockedClaimsCount">
							<td>{{ languageStrings.lockFundsCount }}</td>
							<td class="numerical-font-bold">{{ item.lockedClaimsCount }}</td>
						</tr>
						<!-- <tr v-if="countryCode == 'MX' && getPlaythroughProgressAndThreshold(item)!= null">
							<td>{{ languageStrings.playthroughProgress }}</td>
							<div class="bold-text">{{ getPercentage(item) }} %</div>
							<td class="progress-bar-section bold-text font-for-progress-bar">
								{{ playThroughProgress }}
								<div class="meter space-between-bar-and-number">
    								<span :id="createId(item)" ></span>
  								</div>
								{{ playThroughThreshold }}
								
							</td>
						</tr> -->
					</table>
				</td>
			</tr>
		</tbody>
	</table>
	</table>
	</div>
</template>

<script>
export default {
	name: "HomeTable",
	props: {
		systemSettings: Object,
		casinosForCodeGeneration: Array,
		playerState: Object,
		languageStrings: Object,
	},
	data() {
		return {
			percentage:null,
			playThroughProgress: null,
			playThroughThreshold: null,
			casinoIdNumber: 0,
			casinoBalanceToShow: [],
			casinoName: "",
		};
	},
	watch: {
		percentage(){
		},
		casinoIdNumber() {
			this.casinoBalanceToShow = [];
			for(let i=0; i < this.casinosForCodeGeneration.length; i++) {
				
				if(this.casinoIdNumber == this.casinosForCodeGeneration[i].id) {
					this.casinoBalanceToShow.push(this.casinosForCodeGeneration[i]);
					this.playerState.casinoId = this.casinosForCodeGeneration[i].id;
					let _state = this.playerState;
					this.eventBus.emit("updatePlayerState", _state);
					this.casinoName = this.casinosForCodeGeneration[i].name;
				}
			}
		}
	},
	created() {
		if(this.playerState.casinoId) {
			for(let i=0; i < this.casinosForCodeGeneration.length; i++) {

				if (this.playerState.casinoId == this.casinosForCodeGeneration[i].id) {
					this.casinoBalanceToShow.push(this.casinosForCodeGeneration[i]);
				}
			}
		}
		else{
			this.casinoBalanceToShow.push(this.casinosForCodeGeneration[0]);
		}
		this.casinoIdNumber =this.casinoBalanceToShow[0].id;
		
	},
	mounted() {
		if(this.countryCode == 'MX') this.setOpenClass(0);
	},
	methods: {
		requestOpenQRCodeModal() {
			this.eventBus.emit("requestQRModal", this.playerState.casinoId);
		},

		setOpenClass(index) {
			var currentRow = document.getElementById(`row-${index}`);
			currentRow.classList.contains("open") ?  (currentRow.classList.remove("open")) :(currentRow.classList.add("open"));
			
		},

		getPercentage(item) {
			for(let i = 0; i < this.playerState.casinoBalances.length; i++) {
				if(item.id == this.playerState.casinoBalances[i].casinoId) {
					
					if(this.playerState.casinoBalances[i].playthroughProgressAU == 0 && this.playerState.casinoBalances[i].playthroughThresholdAU == 0){ return null;}

					this.percentage = Math.floor((this.playerState.casinoBalances[i].playthroughProgressAU / this.playerState.casinoBalances[i].playthroughThresholdAU) * 100);
					
					return this.percentage;
				}
			}
			return null;
		},

		getPlaythroughProgressAndThreshold(item) {
			for(let i = 0; i < this.playerState.casinoBalances.length; i++) {
				if(item.id == this.playerState.casinoBalances[i].casinoId) {

					if(this.playerState.casinoBalances[i].playthroughProgressAU == 0 && this.playerState.casinoBalances[i].playthroughThresholdAU == 0) { return null;}

					this.playThroughProgress = item.currencyTool.formatFromAU(this.playerState.casinoBalances[i].playthroughProgressAU, item.currencyTool.displayType.full);
					this.playThroughThreshold = item.currencyTool.formatFromAU(this.playerState.casinoBalances[i].playthroughThresholdAU, item.currencyTool.displayType.full);
					let progress = this.playThroughProgress +" out of " + this.playThroughThreshold;
					return progress;
				}
			}
			return null;
		},

		createId(item) {
			setTimeout(() => {
				this.setPercentage(item);
			}, 50);
			return `progress-bar-${item.id}`;

		},
		setPercentage(item){
			document.getElementById(`progress-bar-${item.id}`).style.width = `${this.getPercentage(item)}%`;
		}
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2,
h3 {
	text-align: center;
}

#balances-container {
	display: grid;
	margin: auto;
	width: 80%;
	background-color: white;
	border-width: 0 1px 1px 1px;
	border-style: solid;
	box-sizing: border-box;
}

.balances {
	position: relative;
	width: 100%;
	margin: auto;
	border-collapse: separate;
	text-align: center;
	background-color: white;
	/* border: 1px solid #6305C9; */
	border-spacing: 0 0.7em;
	/* box-shadow: 0px 6px 10px 0px rgb(0 0 0 / 50%); */
}

.balances tr {
	transition: background-color 0.3s;
	height: 40px;
}


.balances thead {
	border: 1px solid black;
}

tr.header-row {
	position: sticky;
	top: 0;
	background-color: black;
	color: #fff;
	border-bottom: 1px solid black;
	white-space: break-spaces;
	height: 47px;
}

tr td:first-of-type {
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}

tr td:last-of-type {
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}

.encore-color {
	background-color: #6305C9;
	color: white;
}

.panel {
	background-color: black !important;
	color: white;
	display: none;
}

.open .panel {
	display: flex;
	flex-direction: column;
	display: table-row;
}

.numerical-font-bold {
	font-weight: bold;
}

.arrow  {
	color: #000;
	border: #000;
}

.encore-text-color {
	color: #6305C9;
}

.second-table-container {
	width: 96%;
}

.full-width {
	width: 100%;
}

tbody:hover {
	cursor: pointer;
}

.custom-bar {
	width: 60%;
	margin: 0;
}

progress::-webkit-progress-value {
	/* background:  green 100%; */
	/* -webkit-mask:linear-gradient(#fff 0 0);
	background-image: linear-gradient(to right, #e5405e 0%, #ffdb3a 45%,  #3fffa2 100%); */
}

.meter {
	box-sizing: content-box;
  	height: 8px;
  	position: relative;
  	background: #ccc;
  	border-radius: 25px;
  	padding: 7px;
  	box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.507);
	width: 70%;
}

.meter > span {
  display: block;
  height: 100%;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  background-color: #6305C9;
  background-image: linear-gradient(
    center bottom,
   #6305C9 37%,
   #6305C9 69%
  );
  box-shadow: inset 0 2px 9px rgba(255, 255, 255, 0.3),
    inset 0 -2px 6px rgba(0, 0, 0, 0.4);
  position: relative;
  overflow: hidden;
}

.meter > span:after,
.animate > span > span {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-image: linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
  z-index: 1;
  background-size: 50px 50px;
  animation: move 2s linear infinite;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  overflow: hidden;
}

.animate > span:after {
  display: none;
}

.progress-bar-percentage {
	margin-left: 3%;
}

.progress-bar-section {
	display: flex;
	margin-top: 1vh;
	align-items: center;
}

.space-between-bar-and-number {
	margin-left: 5px;
	margin-right: 5px;
}

@keyframes move {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 50px 50px;
  }
}

progress {
	height: 15px !important;
	overflow: hidden;
	border-radius: 35px !important;
}

.bold-text {
	font-weight: bold;
}



select {
	width: 32%;
	margin-left: auto;
	margin-right: auto;
	margin-top: 10px;
}

@-moz-document url-prefix() {
	.panel {
		background-color: transparent !important;
	}
}

@media (max-width: 767px) {
	#balances-container {
		width: 90%;
	}
	.progress-bar-percentage {
		font-size: 13px;
	}
	.font-for-progress-bar {
		font-size: 12px;
	}
}
</style>
